// Valores de atributos personalizados do tipo lista não têm cor própria
// (diferente das labels do Chatwoot, que já vêm com cor cadastrada) —
// então ciclamos por essa paleta fixa, uma cor por coluna, na ordem em
// que os itens aparecem na lista do atributo.
export const COLUMN_COLOR_PALETTE = [
  '#1f93ff',
  '#fb9f3b',
  '#8b5cf6',
  '#3cbc8d',
  '#f43f5e',
  '#eab308',
  '#06b6d4',
  '#ec4899',
];

export const colorForIndex = index =>
  COLUMN_COLOR_PALETTE[index % COLUMN_COLOR_PALETTE.length];
